import {Component, OnInit, Injector, Input} from '@angular/core';
import {AppComponentBase} from '../../../services/AppComponentBase';
import {IAppStoreProduct} from '../interfaces/appstore-interfaces';
import {showAppProductViewModal} from '../appproduct-view/show-AppProductView-modal';
import {showBuyingProcessModal} from '../appproduct-buypopup/appproduct-buypopup-modal';

@Component({
    selector: 'app-appproduct-tile',
    template: require('./appproduct-tile.component.html'),
    styles: [require('./appproduct-tile.component.scss')]
})
export class AppproductTileComponent extends AppComponentBase implements OnInit {


    @Input()
    productId: number = -1;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
    }


    public get productInformation(): IAppStoreProduct {
        return this.workspace.producsList.filter(v => {
            return v.productId == this.productId.toString();
        })[0];
    }

    public showProductDetails() {
        showAppProductViewModal(this.modalService, this.workspace.mobileMode).productId = this.productId;
    }



}
